import { MotionConfig } from "framer-motion";
import { SEO } from "@/components/site/SEO";
import { JsonLd, breadcrumbSchema, webPageSchema } from "@/components/site/Schema";
import { AuthorByline } from "@/components/site/AuthorByline";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { StickyCta } from "@/components/site/StickyCta";
import {
  InfiniteBankingHero, HiddenFinancialProblem, BankingFunctionDiagram, MoneyFlows,
  CapitalCycleDiagram, SupportingToolSection, ProperlyStructured, RealLifeUses,
  FinancingComparison, CoachingTimeline, IbPolicyStack, VideoShelf, MasteringMoneyClosing,
} from "@/components/infinite-banking/InfiniteBankingSections";

export default function InfiniteBanking() {
  return (
    <div className="min-h-screen bg-ivory" data-testid="infinite-banking-page">
      <SEO title="Infinite Banking: A Family Banking System | Legacy Life & Retirement" description="Learn how Infinite Banking organizes cash flow, capital, financing, repayment, liquidity, and legacy planning using participating whole life insurance as a supporting tool." />
      <JsonLd id="ld-ib-breadcrumb" data={breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Infinite Banking", path: "/infinite-banking" }])} />
      <JsonLd id="ld-ib-webpage" data={webPageSchema({ path: "/infinite-banking", name: "Infinite Banking: A Family Banking System", withAuthor: true })} />
      <MotionConfig reducedMotion="user">
        <Header />
        <main>
          <InfiniteBankingHero />
          <div className="container-lr pt-8"><AuthorByline /></div>
          <HiddenFinancialProblem />
          <BankingFunctionDiagram />
          <MoneyFlows />
          <CapitalCycleDiagram />
          <SupportingToolSection />
          <ProperlyStructured />
          <RealLifeUses />
          <FinancingComparison />
          <CoachingTimeline />
          <IbPolicyStack />
          <VideoShelf />
          <MasteringMoneyClosing />
        </main>
        <Footer />
        <StickyCta />
      </MotionConfig>
    </div>
  );
}
